module.exports = __webpack_public_path__ + "img/npsPie.76576109.png";